import React from 'react';
import {
  Container,
  LabelsHolder,
  LabelHolder,
  Label,
  HiddenLabel,
  LogoutIcon,
  Separator,
} from './style';
import NotificationIcon from './components/notification-icon';
import LogoutConfirmationModal from './components/logout-confirmation-modal';
import { useLoggedUser } from 'state/user';
import { removeToken, removeAdminToken } from 'services/storage';
import { clearStore } from 'services/apollo-client';
import { useHistory } from 'react-router';
import { useSpring } from 'react-spring';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { gql, useQuery } from '@apollo/client';
import styled from 'styled-components';

const StyledA = styled.a`
  /* background-color: red; */
  /* height: 100vh; */
  color: ${({ theme }) => theme.text};
  text-align: left;
  /* margin-bottom: 20px; */
  font-size: 20px;
  margin-right: 10px;
  margin-left: 10px;
  /* position: absolute; */
`;

export const querstionairesQuery = gql`
  query questionnaires($id: ID!) {
    questionnaireForSurface(id: $id) {
      data {
        id
        surface {
          id
          name
          description
          rating
          ratingComment
        }
        questions {
          id
          # hint
          question
          type
          order
          hint
          required
        }
      }
    }
  }
`;

export default function QuestionaireUI({ surface }) {
  const history = useHistory();
  // const modal = React.useRef<any>(null);
  // const hiddenLabelRef = React.createRef();

  const { data } = useQuery(querstionairesQuery, {
    variables: { id: surface },
    // fetchPolicy: 'cache-only',
  });

  const questionsData = data?.questionnaireForSurface?.data ?? null;

  console.log('data', questionsData?.surface);

  // const labelHolderWidthAnimation = useSpring({
  //   from: { width: 0 },
  //   to: { width: fullNameLabelWidth },
  //   config: { duration: 500 },
  // });

  // const opacityAnimation = useSpring({
  //   from: { opacity: 0 },
  //   to: { opacity: fullNameLabelWidth > 0 ? 1 : 0 },
  //   delay: 450,
  // });

  // function onConfirm() {
  //   removeToken();
  //   removeAdminToken();
  //   clearStore();
  //   clearClipboard();
  //   history.push('/login'); // redirect user to login page
  // }

  // function showLogOutModal() {
  //   modal.current.show();
  // }

  // React.useEffect(() => {
  //   const hiddenLabelElement = hiddenLabelRef.current as HTMLElement;
  //   setFullNameLabelWidth(hiddenLabelElement.getBoundingClientRect().width);
  // }, [hiddenLabelRef, fullName]);

  if (!questionsData?.questions?.length) {
    return null;
  }

  return (
    <>
      {/* <LogoutConfirmationModal ref={modal} width="30%" onConfirm={onConfirm} /> */}
      <Container>
        {questionsData.questions?.length} Fragen
        <StyledA
          href={`${process.env.REACT_APP_HOST_URL}/share/cortlex/${surface}`}
          target="_blank">
          Link zum Fragebogen
        </StyledA>
        {/* <NotificationIcon style={opacityAnimation} />
        <Separator />
        <LabelsHolder>
          <HiddenLabel ref={hiddenLabelRef}>{fullName}</HiddenLabel>
          <LabelHolder style={labelHolderWidthAnimation}>
            <Label style={opacityAnimation}>{fullName}</Label>
          </LabelHolder>
        </LabelsHolder>
        <LogoutIcon onClick={showLogOutModal} /> */}
      </Container>
    </>
  );
}
